const socialsData = {
  facebook: {
    label: 'Facebook',
  },
  twitter: {
    label: 'X',
  },
  instagram: {
    label: 'Instagram',
  },
  threads: {
    label: 'Threads',
  },
  linkedin: {
    label: 'LinkedIn',
  },
  weddingwire: {
    label: 'WeddingWire',
  },
  pinterest: {
    label: 'Pinterest',
  },
  theknot: {
    label: 'The Knot',
  },
  youtube: {
    label: 'YouTube',
  },
  soundcloud: {
    label: 'SoundCloud',
  },
  spotify: {
    label: 'Spotify',
  },
  tiktok: {
    label: 'TikTok',
  },
  linktree: {
    label: 'Linktree',
  },
  letterboxd: {
    label: 'Letterboxd',
  },
  substack: {
    label: 'Substack',
  },
  weblink: {},
};

export default {
  socialsData,
  blockedForVerifiedUser: function (socialType) {
    return ['facebook', 'linkedin', 'instagram', 'tiktok', 'twitter', 'youtube', 'pinterest', 'threads'].includes(socialType);
  },

  determineLinkType: function (url) {
    let formattedSocialLink = url.toLowerCase();

    if (formattedSocialLink.url == '') {
      return '';
    } else {
      if (formattedSocialLink.includes('facebook.')) {
        return 'facebook';
      } else if (formattedSocialLink.includes('linkedin.')) {
        return 'linkedin';
      } else if (formattedSocialLink.includes('twitter.') || formattedSocialLink.includes('x.com')) {
        return 'twitter';
      } else if (formattedSocialLink.includes('instagram.')) {
        return 'instagram';
      } else if (formattedSocialLink.includes('weddingwire.')) {
        return 'weddingwire';
      } else if (formattedSocialLink.includes('pinterest.')) {
        return 'pinterest';
      } else if (formattedSocialLink.includes('theknot.')) {
        return 'theknot';
      } else if (formattedSocialLink.includes('youtube.')) {
        return 'youtube';
      } else if (formattedSocialLink.includes('soundcloud.')) {
        return 'soundcloud';
      } else if (formattedSocialLink.includes('tiktok.')) {
        return 'tiktok';
      } else if (formattedSocialLink.includes('spotify.')) {
        return 'spotify';
      } else if (formattedSocialLink.includes('linktr.ee')) {
        return 'linktree';
      } else if (formattedSocialLink.includes('letterboxd.')) {
        return 'letterboxd';
      } else if (formattedSocialLink.includes('substack.')) {
        return 'substack';
      } else if (formattedSocialLink.includes('threads.')) {
        return 'threads';
      } else {
        return 'weblink';
      }
    }
  },
};
